import { render } from "./DiseaseDetail.vue?vue&type=template&id=3e3f2863"
import script from "./DiseaseDetail.vue?vue&type=script&lang=js"
export * from "./DiseaseDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__